import { EUserStatus } from './userStatus';
import type { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';

export type TUserStatusRating = {
  value: EUserStatus | null;
};

export type TAnswer = {
  value: string;
};

export type TName = {
  value: string | null;
};

export type TIsAnonymous = {
  value: boolean | null;
};

export enum ENewAnswerModalStep {
  Answer = 'answer',
  Success = 'success',
  Error = 'error',
}

export interface INewAnswer {
  meta: {
    openId: TSetNewAnswerFormOpenPayload | null;
    step: ENewAnswerModalStep;
  };
  data: {
    name: TName;
    userStatus: TUserStatusRating;
    answer: TAnswer;
    isAnonymous: TIsAnonymous;
  };
}
